var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5601,
    cy: 80.7373,
    r: 80.2607,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3474_38986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5601 100.738C64.5601 96.4948 66.2458 92.4252 69.2464 89.4246C72.2469 86.424 76.3166 84.7383 80.5601 84.7383C84.8035 84.7383 88.8732 86.424 91.8738 89.4246C94.8743 92.4252 96.5601 96.4948 96.5601 100.738H92.5601C92.5601 97.5557 91.2958 94.5034 89.0453 92.253C86.7949 90.0026 83.7427 88.7383 80.5601 88.7383C77.3775 88.7383 74.3252 90.0026 72.0748 92.253C69.8243 94.5034 68.5601 97.5557 68.5601 100.738H64.5601ZM80.5601 82.7383C73.9301 82.7383 68.5601 77.3683 68.5601 70.7383C68.5601 64.1083 73.9301 58.7383 80.5601 58.7383C87.1901 58.7383 92.5601 64.1083 92.5601 70.7383C92.5601 77.3683 87.1901 82.7383 80.5601 82.7383ZM80.5601 78.7383C84.9801 78.7383 88.5601 75.1583 88.5601 70.7383C88.5601 66.3183 84.9801 62.7383 80.5601 62.7383C76.1401 62.7383 72.5601 66.3183 72.5601 70.7383C72.5601 75.1583 76.1401 78.7383 80.5601 78.7383Z",
    fill: "#093549"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3474_38986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(56.5601 56.7383)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.80107dfe6c994583290e82b9ed729004.svg";
export { ForwardRef as ReactComponent };